export const showModalInputOrderFinish = () => ({
  type: "SHOW_MODAL_INPUT_ORDER_FINISH",
});

export const closeModalInputOrderFinish = () => ({
  type: "CLOSE_MODAL_INPUT_ORDER_FINISH",
});
